import {Hub} from 'yougile-model'
import {Sync} from '../../client/sync'
import {SyncListeners} from '../../client/sync-listeners'
import {FullTaskChatProxy} from '../../extensions/proxies/full-task-chat-proxy'
import {createSyncedEnhancerContainer} from '../synced-enhancer-container'
import {
  EnhancedWithFullTaskChatProps,
  EnhancedWithFullTaskChatState,
  EnhancedWithFullTaskChatViewContract
} from './types'

export const createEnhancedWithSyncedFullTaskChat = <
  ViewProps extends EnhancedWithFullTaskChatViewContract
>(
  View: React.ComponentType<ViewProps>
) => {
  const subscribe = (
    update: () => void,
    {companyId, chatId}: EnhancedWithFullTaskChatProps<ViewProps>
  ) => {
    SyncListeners.addListener(update, companyId, chatId)
  }

  const unsubscribe = (update: () => void) => {
    SyncListeners.removeListener(update)
  }

  const stateFromProps = ({
    chatId,
    companyId
  }: EnhancedWithFullTaskChatProps<ViewProps>) => {
    const box = Sync.get({companyId})
    const task = box && (box.get(chatId) as Hub)

    return task && FullTaskChatProxy.createForCurrentUser(task)
  }

  type Prop = keyof EnhancedWithFullTaskChatProps<ViewProps>

  const resubscribeOnPropChange = (): Prop[] => ['companyId', 'chatId']

  return createSyncedEnhancerContainer<
    EnhancedWithFullTaskChatProps<ViewProps>,
    EnhancedWithFullTaskChatState,
    EnhancedWithFullTaskChatViewContract,
    ViewProps
  >(View, subscribe, unsubscribe, stateFromProps, resubscribeOnPropChange)
}
